/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2022-07-06 16:17:33
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-07-02 10:24:21
 */
import request from '../request'

enum Api {
  GET_EXPRESS_COMPANY_LIST = '/express/list',
  ADD_EXPRESS_COMPANY = '/express/save',
  EDIT_EXPRESS_COMPANY = '/express/edit',
  GET_EXPRESS_LIST = '/express/expressList',
  GET_EXPRESS_CODE_LIST = '/express/expressCodeList'
}

export default class expressService {
  /**
   * 获取快递公司列表
   * @param data any
   * @returns Promise
   */
  static getExpressCompanyList(data: any): Promise<any> {
    return request.post(Api.GET_EXPRESS_COMPANY_LIST, data)
  }

  /**
   * 新增快递公司
   * @param data any
   * @returns Promise
   */
  static addExpressCompany(data: any): Promise<any> {
    return request.post(Api.ADD_EXPRESS_COMPANY, data)
  }

  /**
   * 修改快递公司
   * @param data any
   * @returns Promise
   */
  static editExpressCompany(data: any): Promise<any> {
    return request.post(Api.EDIT_EXPRESS_COMPANY, data)
  }

  /**
   * 获取所有快递公司
   * @param data any
   * @returns Promise
   */
  static getExpressList(): Promise<any> {
    return request.post(Api.GET_EXPRESS_LIST)
  }

  /**
   * 获取所有快递公司编码
   * @param data any
   * @returns Promise
   */
  static getExpressCodeList(): Promise<any> {
    return request.get(Api.GET_EXPRESS_CODE_LIST)
  }
}
